import React from 'react';
import '../template-file-css/document-file-template.css';


export const FHH_ClinicalSupervisionForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='FHH_ClinicalSupervisionForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Clinical Supervision Form: Direct Service Personnel</h3></center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Length of Supervision:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLengthOfSupervision' name='txtLengthOfSupervision' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Names of those in attendance:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtattendance' name='txtattendance' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Type of Supervision:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSupervision_Individual' name='rbSupervision' className='add-only' value='Individual Supervision' /> Individual Supervision &nbsp;
                            <input type='radio' id='rbSupervision_Other' name='rbSupervision' className='add-only' value='Group Supervision' /> Group Supervision
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Please check areas addressed in Supervision:</span>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbAssessment' name='cbAssessment' className='add-only' value='Assessment/Writing Skills' /> {`Assessment/Writing Skills (Interviewing/Diag/Int. Summary)`}
                    <br />
                    <input type='checkbox' id='cbReferralSkills' name='cbReferralSkills' className='add-only' value='Referral Skills' /> {`Referral Skills & Coordination of Care (PCP or Other)`}
                    <br />
                    <input type='checkbox' id='cbCaseConsultation' name='cbCaseConsultation' className='add-only' value='Case Consultation' /> Case Consultation or Hx Review
                    <br />
                    <input type='checkbox' id='cbTimeManagement' name='cbTimeManagement' className='add-only' value='Time Management' /> {`Time Management (Scheduling Job Requirements)`}
                    <br />
                    <input type='checkbox' id='cbTreatmentEfficacy' name='cbTreatmentEfficacy' className='add-only' value='Treatment Efficacy' /> {`Treatment Efficacy (Length of time in Tx, Type of Tx)`}
                    <br />
                    <input type='checkbox' id='cbTreatmentInterventions' name='cbTreatmentInterventions' className='add-only' value='Treatment Interventions' /> {`Treatment Interventions (Language, Type, Implementation)`}
                    <br />
                    <input type='checkbox' id='cbProgressReview' name='cbProgressReview' className='add-only' value='Progress Review' /> {`Progress Review (Goals/Objectives)`}
                    <br />
                    <input type='checkbox' id='cbGoalDevelopment' name='cbGoalDevelopment' className='add-only' value='Goal Development' /> Goal Development or Tx Plan Update
                    <br />
                    <input type='checkbox' id='cbFidelityToward' name='cbFidelityToward' className='add-only' value='Fidelity Toward' /> {`Fidelity Toward Evidence-Based Practices (Theory Review)`}
                    <br />
                    <input type='checkbox' id='cbSuicideRisk' name='cbSuicideRisk' className='add-only' value='Suicide Risk' /> {`Suicide Risk (Suicide Ideation/Plan, Self-Harm, Aggression/Violence)`}
                    <br />
                    <input type='checkbox' id='cbOtherRiskFactors' name='cbOtherRiskFactors' className='add-only' value='Other Risk Factors' /> {`Other Risk Factors (Addiction, Food, Gambling, Bx Changes, etc.)`}
                    <br />
                    <input type='checkbox' id='cbRiskManagementIssues' name='cbRiskManagementIssues' className='add-only' value='Risk Management Issues' /> Risk Management Issues
                    <br />
                    <input type='checkbox' id='cbCrisisIntervention' name='cbCrisisIntervention' className='add-only' value='Crisis Intervention Skills' /> {`Crisis Intervention Skills (Abuse, Neglect, Duty to Warn, etc.)`}
                    <br />
                    <input type='checkbox' id='cbCritical' name='cbCritical' className='add-only' value='Critical' /> {`Critical/Adverse Incident Reporting (Definition, P&Ps, Follow-up)`}
                    <br />
                    <input type='checkbox' id='cbSessionObservation' name='cbSessionObservation' className='add-only' value='Session Observation' /> Session Observation
                    <br />
                    <input type='checkbox' id='cbCulturalCompetency' name='cbCulturalCompetency' className='add-only' value='Cultural Competency' /> Cultural Competency Issues
                    <br />
                    <input type='checkbox' id='cbProfessionalDevelopment' name='cbProfessionalDevelopment' className='add-only' value='Professional Development' /> {`Professional Development (Skill Butiding Continuing Education)`}
                    <br />
                    <input type='checkbox' id='cbCommunicationSkills' name='cbCommunicationSkills' className='add-only' value='Communication Skills' /> {`Communication Skills (Persons Served, Visitors, Staff)`}
                    <br />
                    <input type='checkbox' id='cbWorkplaceProfessionalism' name='cbWorkplaceProfessionalism' className='add-only' value='Workplace Professionalism' /> Workplace Professionalism
                    <br />
                    <input type='checkbox' id='cbProfessionalBoundaries' name='cbProfessionalBoundaries' className='add-only' value='Professional Boundaries' /> Professional Boundaries
                    <br />
                    <input type='checkbox' id='cbCodeOfConduct' name='cbCodeOfConduct' className='add-only' value='Code of Conduct' /> Code of Conduct or Ethics Review
                    <br />
                    <input type='checkbox' id='cbCorporateCompliancy' name='cbCorporateCompliancy' className='add-only' value='Corporate Compliancy' /> {`Corporate Compliancy (Complaints, Grievances, other Violations)`}
                    <br />
                    <input type='checkbox' id='cbLegalStandards' name='cbLegalStandards' className='add-only' value='Legal Standards' /> {`Legal Standards (Licensure Review, Legal Issues, Court)`}
                    <br />
                    <input type='checkbox' id='cbPolicy' name='cbPolicy' className='add-only' value='Policy' /> Policy and/or Procedure Review
                    <br />
                    <input type='checkbox' id='cbLocal' name='cbLocal' className='add-only' value='Local' /> {`Local/State/Federal (Updates, Review, Guidelines)`}
                    <br />
                    <input type='checkbox' id='cbUtilizationReview' name='cbUtilizationReview' className='add-only' value='Utilization Review' /> {`Utilization Review (Billing, Funding)`}
                    <br />
                    <input type='checkbox' id='cbQualityRecord' name='cbQualityRecord' className='add-only' value='Quality Record' /> {`Quality Record Management (Chart Audit, Peer Review)`}
                    <br />
                    <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' /> Other: <br />
                    <input type='text' id='txtSupervisionOther' name='txtSupervisionOther' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>{`Summary and Focus of Supervision Meeting`}</span>
                    <span className='small'>{`(document nature of all activities checked above)`}</span>
                    <textarea id='txtSummaryAndFocus' name='txtSummaryAndFocus' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>{`Assessment of Professional Skills/Competencies`}</span>
                    <span className='small'>{`(can be assessed on the following scale)`}</span>
                    <textarea id='txtSummaryAndFocus' name='txtSummaryAndFocus' className='add-only'></textarea>
                </p>
                <p className='w-750'><span className='small'>
                    <b>0</b>{`-Functioning Below Standard;`} &nbsp;
                    <b>1</b>{`-Needs Improvement;`} &nbsp;
                    <b>2</b>{`-Neutral;`} &nbsp;
                    <b>3</b>{`-Meets Standards;`} &nbsp;
                    <b>4</b>{`-Exceeds Expectations;`}
                </span>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Recommendations for Improvement to be Addressed by Next Meeting</span>
                    <span className='small'>{`(specific timelines)`}</span>
                    <textarea id='txtSummaryAndFocus' name='txtSummaryAndFocus' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Supervisor Signature </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Staff Signature </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                </table>

                <p className='w-750'><center><h3>Client Checklist for Supervision</h3></center>
                </p>

                <table>
                    <tr>
                        <td className='w-125'> <span className='eleHeader'>Month:</span> </td>
                        <td className='w-125'> <span className='eleHeader'>Week:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>MHS/MHP:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>LMHP:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'> <input type='text' id='txtMonth' name='txtMonth' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtWeek' name='txtWeek' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMhs' name='txtMhs' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLmhp' name='txtLmhp' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><center><h4>Current Caseload</h4></center></p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_1' name='txtClients_1' placeholder='1' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_1' name='txtCpst_1' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_1' name='txtPsr_1' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_2' name='txtCpst_2' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_2' name='txtPsr_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_1' name='txtExplanation_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_1' name='txtAssessmentDue_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_1' name='txtLocusDue_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_1' name='txtPocUpdateDue_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_2' name='txtClients_2' placeholder='2' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_3' name='txtCpst_3' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_3' name='txtPsr_3' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_4' name='txtCpst_4' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_4' name='txtPsr_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_2' name='txtExplanation_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_2' name='txtAssessmentDue_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_2' name='txtLocusDue_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_2' name='txtPocUpdateDue_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_3' name='txtClients_3' placeholder='3' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_5' name='txtCpst_5' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_5' name='txtPsr_5' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_6' name='txtCpst_6' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_6' name='txtPsr_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_3' name='txtExplanation_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_3' name='txtAssessmentDue_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_3' name='txtLocusDue_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_3' name='txtPocUpdateDue_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_4' name='txtClients_4' placeholder='4' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_7' name='txtCpst_7' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_7' name='txtPsr_7' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_8' name='txtCpst_8' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_8' name='txtPsr_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_4' name='txtExplanation_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_4' name='txtAssessmentDue_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_4' name='txtLocusDue_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_4' name='txtPocUpdateDue_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_5' name='txtClients_5' placeholder='5' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_9' name='txtCpst_9' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_9' name='txtPsr_9' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_10' name='txtCpst_10' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_10' name='txtPsr_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_5' name='txtExplanation_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_5' name='txtAssessmentDue_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_5' name='txtLocusDue_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_5' name='txtPocUpdateDue_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_6' name='txtClients_6' placeholder='6' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_11' name='txtCpst_11' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_11' name='txtPsr_11' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_12' name='txtCpst_12' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_12' name='txtPsr_12' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_6' name='txtExplanation_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_6' name='txtAssessmentDue_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_6' name='txtLocusDue_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_6' name='txtPocUpdateDue_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_7' name='txtClients_7' placeholder='7' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_13' name='txtCpst_13' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_13' name='txtPsr_13' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_14' name='txtCpst_14' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_14' name='txtPsr_14' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_7' name='txtExplanation_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_7' name='txtAssessmentDue_7' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_7' name='txtLocusDue_7' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_7' name='txtPocUpdateDue_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_8' name='txtClients_8' placeholder='8' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_15' name='txtCpst_15' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_15' name='txtPsr_15' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_16' name='txtCpst_16' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_16' name='txtPsr_16' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_8' name='txtExplanation_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_8' name='txtAssessmentDue_8' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_8' name='txtLocusDue_8' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_8' name='txtPocUpdateDue_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_9' name='txtClients_9' placeholder='9' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_17' name='txtCpst_17' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_17' name='txtPsr_17' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_18' name='txtCpst_18' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_18' name='txtPsr_18' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_9' name='txtExplanation_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_9' name='txtAssessmentDue_9' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_9' name='txtLocusDue_9' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_9' name='txtPocUpdateDue_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients10' name='txtClients_10' placeholder='10' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_19' name='txtCpst_19' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_19' name='txtPsr_19' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_20' name='txtCpst_20' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_20' name='txtPsr_20' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_10' name='txtExplanation_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_10' name='txtAssessmentDue_10' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_10' name='txtLocusDue_10' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_10' name='txtPocUpdateDue_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_11' name='txtClients_11' placeholder='11' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_21' name='txtCpst_21' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_21' name='txtPsr_21' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_22' name='txtCpst_22' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_22' name='txtPsr_22' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_11' name='txtExplanation_11' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_11' name='txtAssessmentDue_11' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_11' name='txtLocusDue_11' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_11' name='txtPocUpdateDue_11' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr/></td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Clients<small>INITIALS ONLY</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>CPST <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>UNITS REMAINING</small></span> </td>
                        <td className='w-125'> <span className='eleHeader'> CPST <small>% USED</small></span>
                        </td>
                        <td className='w-125'> <span className='eleHeader'>PSR <small>% USED</small></span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClients_12' name='txtClients_12' placeholder='12' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_23' name='txtCpst_23' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_23' name='txtPsr_23' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtCpst_24' name='txtCpst_24' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtPsr_24' name='txtPsr_24' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>EXPLANATION FOR POOR PARTICIPATION IF NOT 100%</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtExplanation_12' name='txtExplanation_12' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>ASSESSMENT DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>CA/LOCUS DUE</span></td>
                        <td className='w-250'> <span className='eleHeader'>POC UPDATE DUE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtAssessmentDue_12' name='txtAssessmentDue_12' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLocusDue_12' name='txtLocusDue_12' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPocUpdateDue_12' name='txtPocUpdateDue_12' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Supervisor COMMENTS:</span>
                <input type='text' id='txtSupervisorComments' name='txtSupervisorComments' className='add-only' />
                 </p>

                 <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Supervisor Signature </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> MHS/MHP Signature </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                </table>



            </div>

        </form >
    )
}